import { Injectable, Injector } from '@angular/core';
import Budget from '../../shared/models/budget/budget';
import Address from '../../shared/models/user/address';
import User from '../../shared/models/user/user';
import { AppInfoService } from '../app-info/app-info.service';
import { HttpService } from '../http/http.service';
import { CartService } from './../cart/cart.service';

@Injectable({
  providedIn: 'root',
})
export class BudgetService {
  private cartService: CartService | undefined;

  constructor(
    private injector: Injector,
    private httpService: HttpService,
    private appInfoService: AppInfoService
  ) {}

  private getCartService(): CartService {
    if (!this.cartService) {
      this.cartService = this.injector.get(CartService);
    }
    return this.cartService;
  }

  public get(hash: string): Promise<Budget> {
    return new Promise((resolve, reject) => {
      this.httpService.get(`budget/${hash}`).subscribe({
        next: (res: any) => {
          let newBudget: Budget;
          if (res) {
            newBudget = Object.assign(new Object(), res);
            const user: User = new User();
            user.fromJson(newBudget.user);
            newBudget.user = user;

            let newAddressDelivery: Address = new Address();
            newAddressDelivery.fromJson(newBudget?.addressDelivery);
            newBudget.addressDelivery = newAddressDelivery;

            if (newBudget?.addressInvoicing) {
              let newAddressInvoicing: Address = new Address();
              newAddressInvoicing.fromJson(newBudget?.addressInvoicing);
              newBudget.addressInvoicing = newAddressInvoicing;
            }

            newBudget.carrierDescription =
              this.appInfoService.getCarrierDescription(
                newBudget.carrier || ''
              );

            if (newBudget?.cart) {
              newBudget.cart.cartProducts = this.getCartService().parseCartItem(
                newBudget?.cart?.cartProducts || []
              );

              newBudget.cart.discountSeller = newBudget.discountSeller;
              newBudget.cart.valueFreight = newBudget.valueFreight;
            }

            resolve(newBudget);
          }
        },
        error: (error: any) => {
          const msg =
            error?.error?.message ||
            error?.error?.error ||
            'Ocorreu um erro ao buscar o cupom!';
          reject(msg);
        },
      });
    });
  }
}
